export default ctx => ({
  [ctx.action('read')]: () => {
    ctx.dispatch(ctx.resource.read(ctx.id, ctx.options)).catch(error => {
      throw error;
    });
  },
});
